module.exports = __webpack_public_path__ + "img/Other.82a824e.webp";